import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makePropTypesFactory, makeValidatingTransformFactory } from "./factory";
export var makePropTypes = makePropTypesFactory(function (vars) {
  return {
    badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    badgeColor: PropTypes.oneOf(vars.colors),
    badgeOutlined: PropTypes.bool,
    badgeRounded: PropTypes.bool,
    badgeSize: PropTypes.oneOf(vars.badgeSizes)
  };
});
export var transform = function transform(props) {
  var _classNames;

  var badge = props.badge,
      badgeColor = props.badgeColor,
      badgeOutlined = props.badgeOutlined,
      badgeRounded = props.badgeRounded,
      badgeSize = props.badgeSize,
      className = props.className,
      rest = tslib_1.__rest(props, ["badge", "badgeColor", "badgeOutlined", "badgeRounded", "badgeSize", "className"]);

  return Object.assign({
    className: classNames((_classNames = {
      badge: badge
    }, _defineProperty(_classNames, "has-badge-".concat(badgeColor), badgeColor), _defineProperty(_classNames, "has-badge-outlined", badgeOutlined), _defineProperty(_classNames, "has-badge-rounded", badgeRounded), _defineProperty(_classNames, "has-badge-".concat(badgeSize), badgeSize), _classNames), className)
  }, badge !== undefined ? {
    "data-badge": badge
  } : {}, rest);
};
export var makeValidatingTransform = makeValidatingTransformFactory(makePropTypes, transform);